// Helper function to get padding
const getIconButtonPadding = size => {
  switch (size) {
    case 'small':
      return '8px'
    case 'large':
      return '10px'
    case 'medium':
      return '9px'
    default:
      return '10px'
  }
}

export default getIconButtonPadding
